/* eslint-disable @angular-eslint/component-selector */
import { Component } from '@angular/core';
import { AbstractComponent } from '../abstract-component';

 
@Component({
    // TODO: Unsure if we need to change the selector or not
    selector: 'prutech-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    standalone: false
})
export class AuthComponent extends AbstractComponent {
  override afterOnDestroy(): void {
    // afterOnDestroy
  }
}
